import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'

// Catalogo de clases de iconos 
export const ButtonIcons = {
    DEFAULT: '',
    TEST: 'icon1',
}

// typo de boton
export const ButtonType = {
    BUTTON: 'button',
    RESET: 'reset',
    SUBMIT: 'submit',
}
// Categoria de boton
export const ButtonCategory = {
    PRIMARY: 'btnPrimario',
    TRANS_GRIS: 'btnTransGris',
    TRANS_NEGRO_BLANCO: 'btnTransNegroBlanco',
    // SECUNDARY: 'btn-secondary',
    // TERTIARY: 'btn-tertiary',
    // INFO: 'btn-info',
}
// Tema del botton
export const ButtonTheme = {
    DEFAULT: '',
    DARK: 'btn-dark',
}
// Tamaño del botton
export const ButtonSize = {
    DEFAULT: '',
    BIG: 'btn-big',
    LARGE: 'btn-large',
}

export default function Button (props ) {
    const {
        children,
        icon,
        className,
        disabled,
        onClick, 
        type, 
        category,
        theme, 
        size,
        ariaLabelledby,
        // ariaPressed,
        href,
    } = props

    let classProps = classNames(
        'btn',
        category,
        { 'btn-icon' : icon !== '' },
        icon,
        className,
        theme,
        size,
    )

    return (
        <a
            className={classProps}
            type={type} 
            onClick={onClick} 
            disabled={disabled}
            aria-labelledby={ariaLabelledby}
            // aria-pressed={ariaPressed}
            href={href?href:null}
        > 
            {children}
        </a>
    )
}

Button.propTypes = {
    children: PropTypes.node,
    type: PropTypes.string,
    onClick: PropTypes.func,
    className: PropTypes.string,
    disabled: PropTypes.bool,
    category: PropTypes.string,
    theme: PropTypes.string,
    size: PropTypes.string,
    icon: PropTypes.string,
    ariaLabelledby: PropTypes.string,
    ariaPressed: PropTypes.bool,
}

Button.defaultProps = {
    children: 'Children text',
    type: ButtonType.BUTTON,
    onClick: () => {},
    className: '',
    disabled: false,
    category: ButtonCategory.PRIMARY,
    theme: ButtonTheme.DEFAULT,
    size: ButtonSize.DEFAULT,
    icon: ButtonIcons.DEFAULT,
    ariaLabelledby: '',
    ariaPressed: null,
    href: '',
}